import axios from 'axios';
import { OptionType } from 'components';
import { ContactForm, ContactSouscripteurData, ContractExtended, ContractOptionType, getContractTypeLabel } from 'core/models';

export function getContrats(): Promise<OptionType<string>[]> {
    return axios.get<ContactSouscripteurData>(`/contrats/`).then((data: ContactSouscripteurData) =>
        Object.values(data).reduce<OptionType<string>[]>((result, contrats) => {
            return result.concat(
                Object.keys(contrats)
                    .map((id) => ({
                        value: id,
                        label: `${id} - ${contrats[id].contrat}`,
                    }))
                    .filter((o) => o.value !== 'souscripteur'),
            );
        }, []),
    );
}

export function getContratsExtended(): Promise<ContractOptionType<string>[]> {
    return axios.get<ContractExtended>(`/contrats/extended`).then((data: ContractExtended) =>
        data.map((d) => ({
            value: d.cod,
            label: `${d.lbContrat} --- ${d.lbSouscripteur} --- ${d.type === 'S' ? 'Santé' : 'Prévoyance'} ${getContractTypeLabel(d.codTypeContrat)}`,
            lbRespadhes: d.lbRespadhes,
            lbResppresta: d.lbResppresta,
        })),
    );
}

export function sendContactForm(data: ContactForm) {
    return axios.post('/contacts/comments/new', data);
}
export function sendBoiteAIdeeForm(data: ContactForm) {
    return axios.post('contacts/idea/new', data);
}
